// tslint:disable: no-unused
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '@core/auth/auth.service';

@Injectable()
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const allowedRoles = next.data.allowedRoles;
    const userRole = this.authService.getRole();

    const canAccess =
      allowedRoles && allowedRoles.some((role: string) => role === userRole);

    if (canAccess) {
      return true;
    }

    this.router.navigate(['home']);

    return false;
  }
}
